export const nullUserTimeAccess = {
    timeRestricted: false,
    timeRestrictedPending: false,
    userId: 0,
    userTimeAccessDays: [],
    userTimeAccessDaysPending: [],
    success: false,
    errorMessage: null,
};
